import { BordersStyles, Box, Skeleton } from '@factorialco/deprecated-design-system'

const EmployeeAssignedSkeleton = () => {
  const border: BordersStyles = {
    bottom: {
      width: 's1',
      style: 'solid',
      color: 'grey400',
    },
  }

  return (
    <Box gap="s12" paddingX="s16" paddingY="s12" background="white" border={border}>
      <Box flexDirection="row" gap="s12">
        <Box flexDirection="row">
          <Skeleton width="s48" height="s48" />
        </Box>
        <Box flexDirection="column" gap="s8">
          <Skeleton width="s200" height="s16" />
          <Skeleton width="s200" height="s16" />
          <Skeleton width="s200" height="s24" />
        </Box>
      </Box>
      <Box alignItems="flexEnd" style={{ width: '100%' }} gap="s4" justifyContent="spaceBetween">
        <Box paddingLeft="s8" flexDirection="row" gap="s8">
          <Skeleton width="s96" height="s32" />
        </Box>
      </Box>
    </Box>
  )
}

export default EmployeeAssignedSkeleton
